import { Col, Row } from 'antd';
import { employeeApi } from 'Api/employee';
import { Loader } from 'components/Global';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './index.module.scss';
import Ellipse from 'components/Global/Ellipse';
import { toastText } from 'utils/utils';

const EarningsModal: React.FC<any> = ({
	activeTab,
	setEarningsAmount,
	setEarningsAmountZMW,
	setHasMixedCurrency,
	isUSD,
	setIsLoading,
	isLoading,
}) => {
	const [data, setData] = useState<any>([]);
	const [searchParams] = useSearchParams();

	const fetchEmployeeEarnings = async () => {
		setIsLoading(true);
		try {
			const apiData = await employeeApi.getEmployeeMasterEarnings({
				employeeId: searchParams.get('employeeId'),
			});

			const responseData = apiData?.data?.data || [];
			const isPayrollRun = apiData?.data?.isPayrollRun;

			let finalData = isPayrollRun
				? responseData
				: responseData.filter((item: any) => item.isChecked);

			setData(finalData);
			const zmwItems = finalData.filter(
				(item: any) => isUSD && item.currency === 'ZMW'
			);
			const usdItems = finalData.filter(
				(item: any) => !(isUSD && item.currency === 'ZMW')
			);
			const totalUsd = usdItems.reduce(
				(sum: number, item: any) => sum + Number(item?.amount || '0.00'),
				0
			);
			const totalZmw = zmwItems.reduce(
				(sum: number, item: any) => sum + Number(item?.amount || '0.00'),
				0
			);
			setEarningsAmount(totalUsd);
			setEarningsAmountZMW?.(totalZmw);
			setHasMixedCurrency?.(isUSD && zmwItems.length > 0);
		} catch (error: any) {
			const message =
				error?.response?.data?.error?.description ||
				'Something went wrong in fetching earnings';
			toastText(message, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (activeTab === 'earnings') {
			fetchEmployeeEarnings();
		}
	}, [activeTab]);

	return (
		<>
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
					}}
				>
					<Loader />
				</div>
			) : (
				<div className={styles.earningsContainer}>
					<Row gutter={16}>
						{data.map((item: any) => (
							<Col
								key={item.id || item.description}
								span={12}
								className={styles.earningsItem}
							>
								<div className={styles.earningsContent}>
									<div className={styles.labelContainer}>
										<Ellipse
											maxLength={20}
											message={item?.description}
											isTooltip={true}
											tooltipMessage={item?.description}
											key={item?.description}
										/>
									</div>
									<span className={styles.colon}>:</span>
									{/* :{' '} */}
									<div className={styles.amount}>
										{item.amount}{' '}
										<span
											className={`${styles.rowCurrencyLabel} ${isUSD && item.currency === 'ZMW'
													? styles.currencyZmw
													: isUSD
														? styles.currencyUsd
														: styles.currencyZmw
												}`}
										>
											{isUSD && item.currency === 'ZMW' ? 'ZMW' : isUSD ? 'USD' : 'ZMW'}
										</span>
									</div>
								</div>
							</Col>
						))}
					</Row>
				</div>
			)}
		</>
	);
};

export default EarningsModal;
